import { render, staticRenderFns } from "./UploadingDetailsFields.vue?vue&type=template&id=5f6f0752&scoped=true&"
import script from "./UploadingDetailsFields.vue?vue&type=script&lang=js&"
export * from "./UploadingDetailsFields.vue?vue&type=script&lang=js&"
import style0 from "./UploadingDetailsFields.vue?vue&type=style&index=0&id=5f6f0752&prod&lang=css&"
import style1 from "./UploadingDetailsFields.vue?vue&type=style&index=1&id=5f6f0752&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6f0752",
  null
  
)

export default component.exports